import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=034cc1ae&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=034cc1ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034cc1ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034cc1ae')) {
      api.createRecord('034cc1ae', component.options)
    } else {
      api.reload('034cc1ae', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=034cc1ae&scoped=true&", function () {
      api.rerender('034cc1ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GY1ken26T4ZJ/JS/comp/PopupBox.vue"
export default component.exports